import React from 'react';
import api from 'api';
import jwtDecode from 'jwt-decode';
import Mustache from 'mustache';
import Remarkable from 'remarkable';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, Modal, TextInput, LongTextInput, DropdownSelector, CheckBox } from 'hyperdb-utils';
import { AVAILABLE_LANGUAGES, FILESTORE_URL } from '../../../../../config';
import { generateContextForMessage } from '../../../../../backend/email/api/context';
import { TemplateSelector } from '../../template/containers';
import { CustomersSelector } from '../../../daily-rental/common';

class EmailComposer extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeRecipient = this.handleChangeRecipient.bind(this);
    this.handleCustomerCreated = this.handleCustomerCreated.bind(this);
    this.handleAddAttachment = this.handleAddAttachment.bind(this);
    this.handleCancelRemoveAttachment = this.handleCancelRemoveAttachment.bind(this);
    this.handleConfirmRemoveAttachment = this.handleConfirmRemoveAttachment.bind(this);
    this._initialized = false;
    this.state = {
      indexAttachmentToRemove: -1
    };
  }
  componentDidMount() {
    this.props.api.message.getData({ url: '/get-data-for-compose' })
      .then(({ account, signatureSetting }) => {
        if (this.props.objectData.id) {
          this.props.api.emailTemplate.getCorrespondingTemplate({
            code: this.props.objectData.type,
            templateId: this.props.objectData.template_id.value[1]
          })
          .then(usedTemplate => this.props.api.message.setData({ usedTemplate, account, signatureSetting }))
          .then(() => this._initialized = true)
          .then(() => this.parseMessageContent(this.props.objectData));
        } else {
          const sender = `${account.name} <${account.email}>`;
          const message = { ...this.props.objectData, sender };
          this.props.api.message.updateEditedObject({ data: message, noSetDirty: true });
          this.props.api.message.setData({
            account,
            signatureSetting,
            // defined_template: !this.props.objectData.template_id.value[1] || this.props.objectData.template_id.value[1] === '0',
          })
          .then(() => this._initialized = true)
          .then(() => {
            if (this.props.objectData.type) {
              this.applyTemplate(this.props.objectData);
            }
          });
        }
        if (this.props.forReply) this.parseMessageContent(this.props.objectData);
      });
  }
  componentWillReceiveProps(nextProps) {
    const { type, template_id, language } = nextProps.objectData;
    if (this._initialized) {
      // Change type
      if (type !== this.props.objectData.type) {
        this.applyTemplate(nextProps.objectData, null, '0') // TODO: refactor
          .then(defaultTemplate => {
            if (defaultTemplate) this.handleChangeTemplate('template_id', defaultTemplate.id);
          });
      }
      // Change template
      if (template_id.value[1] !== this.props.objectData.template_id.value[1]) {
        this.applyTemplate(nextProps.objectData);
      }
      /* if (nextProps.defined_template !== this.props.defined_template) {
        nextProps.objectData.template_id.value[1] = null;
        this.applyTemplate(nextProps.objectData);
      }*/
      // Change language
      if (language !== this.props.objectData.language) {
        this.applyTemplate(nextProps.objectData, this.props.usedTemplate);
      }
    }
  }
  componentWillUnmount() {
    this.props.api.message.setData({ recipientEmail: null });
  }

  render() {
    return (
      <div className="box-body">
        <Spinner show={ this.props.loading } />
        <fieldset>
          <CheckBox
            label="Important"
            name="important"
            checked={ this.props.objectData.important }
            onChange={ this.handleChange.bind(this, 'important') }
          />
          <TemplateSelector
            type={ this.props.objectData.type }
            useDefinedTemplate={ this.props.defined_template }
            template={ this.props.objectData.template_id.value[1] }
            onChangeTemplateType={ this.handleChangeTemplate.bind(this, 'type') }
            onChangeChooseDefinedTemplate={ this.handleChangeTemplate.bind(this, 'defined_template') }
            onChangeTemplate={ this.handleChangeTemplate.bind(this, 'template_id') }
          />
          <DropdownSelector
            label="Language"
            name="language"
            options={ this.languagesOptions(AVAILABLE_LANGUAGES) }
            value={ this.props.objectData.language }
            onChange={ this.handleChange.bind(this, 'language') }
          />
          <TextInput
            disabled={ true }
            label="Sender *"
            name="sender"
            value={ this.props.objectData.sender }
          />
          <CustomersSelector
            customerId={ this.props.objectData.recipient }
            forEmail={ true }
            required={ true }
            option={ (c) => ({ name: `${c.name || ''} <${c.entity.primary_email}>`, value: `${c.name || ''} <${c.entity.primary_email}>` }) }
            onChange={ this.handleChangeRecipient }
            onCustomerCreated={ this.handleCustomerCreated }
            noCreate={ this.props.hasOwnProperty('canCreateCustomer') ? !this.props.canCreateCustomer : false }
          />
          <TextInput
            label="Subject *"
            name="subject_draft"
            value={ this.props.objectData.subject_draft }
            onChange={ this.handleChange.bind(this, 'subject_draft') }
          />
          <LongTextInput
            label="Body"
            name="body_draft"
            value={ this.props.objectData.body_draft }
            onChange={ this.handleChange.bind(this, 'body_draft') }
          />
          {
            this.props.objectData.replied_message_id && this.props.objectData.replied_message_id.value[1]
              ? <CheckBox
                  label="Quote replied message"
                  name="quote_replied_message"
                  checked={ this.props.objectData.quote_replied_message }
                  onChange={ this.handleChange.bind(this, 'quote_replied_message') }
                />
              : null
          }
          {
            this.props.objectData.replied_message_id && this.props.objectData.replied_message_id.value[1]
              ? <iframe id="quoted-message-iframe" name="preview-frame" width="100%" height="200px" srcDoc={ this.props.quotedMessage }></iframe>
              : null
          }
        </fieldset>
        {
          !this.props.disallowAttachments
            ? <fieldset>
                <legend>
                  Attachments &nbsp;
                  <label htmlFor="attachment" className="btn btn-primary btn-sm">
                    <i className="fas fa-upload"></i> Add attachment
                  </label>
                </legend>
                <input type="file" id="attachment" onChange={ this.handleAddAttachment } style={ {display: 'none'} } />
                <ul>
                {
                  (this.props.attachments || []).map((attachment, i) => {
                    return (
                      <li key={ i }>
                        {
                          attachment._new
                            ? attachment.filename
                            : <a href={ this.attachmentsBaseUrl() + attachment.filename } target="_blank">{ attachment.filename }</a>
                        } &nbsp;
                        <button type="button" className="btn btn-danger btn-xs" onClick={ this.handleRemoveAttachment.bind(this, i) }>
                          <i className="fas fa-remove" /> Remove
                        </button>
                      </li>
                    );
                  })
                }
                </ul>
              </fieldset>
            : null
        }
        {
          this.state.indexAttachmentToRemove !== -1
            ? <Modal show={ true } onAccept={ this.handleConfirmRemoveAttachment } onClose={ this.handleCancelRemoveAttachment } title="Remove attachment">
                <p><strong className="text-danger">Warning</strong></p>
                <p><span className="danger">
                  Are you sure you want to remove this attachment <strong>{ this.props.attachments[this.state.indexAttachmentToRemove].filename }</strong> ?
                </span></p>
              </Modal>
            : null
        }
      </div>
    );
  }

  languagesOptions(languages) {
    return languages.map(l => ({ name: l, value: l }));
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    if (attributeName === 'important') {
      const checked = !this.props.objectData[attributeName];
      this.props.api.message.updateEditedObject({ attributeName, value: checked });
    } else if (attributeName === 'subject_draft' || attributeName === 'body_draft' || attributeName === 'quote_replied_message') {
      this.parseMessageContent(this.props.objectData, { attributeName, value });
    } else {
      this.props.api.message.updateEditedObject({ attributeName, value });
    }
  }
  handleChangeTemplate(attributeName, value) {
    if (attributeName === 'type') {
      this.props.api.message.updateEditedObject({ attributeName, value });
    }
    /* if (attributeName === 'defined_template') {
      this.props.api.message.setData({ defined_template: value });
    }*/
    if (attributeName === 'template_id') {
      const relation = { ...this.props.objectData.template_id, value: ['email_templates', value] };
      this.props.api.message.updateEditedObject({ attributeName, value: relation });
    }
  }
  /* handleChangeRecipient(email) {
    const selectedEntity = this.props.api.getState('customer').entities
      .find(e => e.primary_email === email);
    const selectedCustomer = this.props.api.getState('customer').customers.find(c => {
      return c.entity.value[1] === selectedEntity.id;
    });
    const recipient = `${selectedCustomer.name || ''} <${selectedEntity.primary_email}>`;
    this.props.api.message.updateEditedObject({ attributeName: 'recipient', value: recipient });
    if (this.props.onSelectCustomer) this.props.onSelectCustomer(selectedCustomer);
  }*/
  handleChangeRecipient(recipient) {
    this.props.api.message.updateEditedObject({ attributeName: 'recipient', value: recipient });
    this.props.api.message.setData({ recipientEmail: recipient })
      .then(() => {
        this.applyTemplate(this.props.objectData, this.props.usedTemplate);
      });
  }
  handleCustomerCreated(customer) {
    const recipient = `${customer.name} <${customer.entity_data.primary_email}>`;
    this.handleChangeRecipient(recipient);
    /* this.props.api.message.updateEditedObject({ attributeName: 'recipient', value: recipient });
    if (this.props.onSelectCustomer) this.props.onSelectCustomer(customer);*/
  }

  applyTemplate(message, emailTemplate = null, templateId = null) {
    const promiseTemplate = emailTemplate
      ? Promise.resolve(emailTemplate)
      : this.props.api.emailTemplate.getCorrespondingTemplate({
        code: message.type,
        templateId: templateId || message.template_id.value[1]
      });
    return promiseTemplate
      .then(usedTemplate => {
        this.props.api.message.setData({ usedTemplate });
        const opts = {};
        let subject = '';
        let body = '';
        if (usedTemplate) {
          opts.mode = usedTemplate.mode;
          subject = (usedTemplate.subject.$i18n || {})[message.language];
          body = (usedTemplate.body.$i18n || {})[message.language];
        }
        const emailContext = this.generateContext();
        this.parseEmail({ ...message, subject_draft: subject, body_draft: body }, emailContext, opts);
        return usedTemplate;
      });
  }
  parseMessageContent(message, field = null) {
    const opts = {};
    if (this.props.usedTemplate) opts.mode = this.props.usedTemplate.mode;
    const emailContext = this.generateContext();
    if (field) {
      let value = field.value;
      if (field.attributeName === 'quote_replied_message') {
        value = !message[field.attributeName];
      }
      this.parseEmail({ ...message, [field.attributeName]: value }, emailContext, opts);
    } else {
      this.parseEmail(message, emailContext, opts);
    }
  }

  parseEmail(message, context, opts = {}) {
    const { mode } = opts;
    try {
      const md = new Remarkable({ html: true, breaks: true });
      Mustache.escape = (val) => val; // Don't escape html strings in text
      const email = { ...message };
      email.subject = Mustache.render(email.subject_draft || '', context || {});
      email.body = Mustache.render(email.body_draft || '', context || {});
      if (mode === 'markdown') email.body = md.render(email.body);
      if (message.quote_replied_message && this.props.quotedMessage) {
        email.body += `<blockquote style="border-left: 2px solid blue; padding-left: 10px;">${this.props.quotedMessage}</blockquote>`;
      }
      this.props.api.message.updateEditedObject({ data: email, noSetDirty: true });
    } catch (e) {
      this.props.api.message.updateEditedObject({ data: message, noSetDirty: true });
    }
  }

  generateContext() {
    const { currentUser } = this.props.api.getState('auth');
    const { account, signatureSetting } = this.props;
    const website = currentUser.client_id === '3912abc1' || currentUser.client_id === '39123912' || currentUser.client_id === '12345678' // TODO
      ? {
        url: 'http://www.apartmentsbcn.com',
        module_slugs: {
          en: 'apartments-barcelona',
          fr: 'appartements-barcelone',
          es: 'apartamentos-barcelona',
          it: 'appartamenti-barcellona',
          de: 'ferienwohnungen-in-barcelona',
          nl: 'apartments-barcelona',
        }
      }
      : { url: '', module_slugs: {} };
    return generateContextForMessage({
      language: this.props.objectData.language,
      account,
      signatureSetting,
      currentUser,
      website,
      relatedObject: this.props.relatedObject,
      searchAvailabilities: this.props.searchAvailabilities,
      recipientEmail: this.props.recipientEmail,
    });
  }

  attachmentsBaseUrl() {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    return `${FILESTORE_URL}/${decoded.client_id}/messages/${this.props.objectData.id}/attachments/`;
  }
  handleAddAttachment(evt) {
    const file = evt.currentTarget.files[0];
    const attachments = this.props.attachments.concat({ filename: file.name, file, _new: true });
    this.props.api.message.setData({ attachments });
  }
  handleRemoveAttachment(index) {
    this.setState({ indexAttachmentToRemove: index });
  }
  handleCancelRemoveAttachment() {
    this.setState({ indexAttachmentToRemove: -1 });
  }
  handleConfirmRemoveAttachment() {
    const attachments = this.props.attachments.slice();
    attachments.splice(this.props.indexAttachmentToRemove, 1);
    this.props.api.message.setData({ attachments });
    this.setState({ indexAttachmentToRemove: -1 });
  }
}

EmailComposer.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
  usedTemplate: React.PropTypes.object,
  loading: React.PropTypes.bool,
  forReply: React.PropTypes.bool,
  defined_template: React.PropTypes.bool,
  quotedMessage: React.PropTypes.string,
  disallowAttachments: React.PropTypes.bool,
  attachments: React.PropTypes.array,
  indexAttachmentToRemove: React.PropTypes.number,
  relatedObject: React.PropTypes.object,
};

export default api.connect(EmailComposer, 'message', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/EmailComposer.jsx